export const DEFAULT_SERVICES = [
  {
    slug: "pendirian-pt-cv",
    title: "Pendirian PT/CV & Badan Usaha",
    short:
      "Pembuatan akta pendirian PT, CV, Yayasan, Koperasi, dan badan usaha lainnya beserta pengurusan legalitas.",
    description:
      "Layanan pendirian PT/CV, perubahan anggaran dasar, SK Kemenkumham, dan legalitas usaha untuk klien di Indramayu.",
    items: ["Akta Pendirian PT/CV", "Perubahan Anggaran Dasar", "SK Kemenkumham", "NIB & Izin Usaha"],
  },
  {
    slug: "akta-jual-beli",
    title: "Akta Jual Beli Tanah & Properti",
    short: "Pembuatan AJB, PPJB, balik nama sertifikat, serta pengecekan keabsahan dokumen properti.",
    description:
      "Layanan akta jual beli tanah dan properti di Indramayu termasuk dokumen AJB, PPJB, dan balik nama sertifikat.",
    items: ["AJB & PPJB", "Balik Nama Sertifikat", "Hak Tanggungan", "APHT"],
  },
  {
    slug: "waris-hibah",
    title: "Hukum Waris & Hibah",
    short: "Pembuatan surat keterangan waris, akta hibah, pembagian harta warisan secara legal dan tertib.",
    description:
      "Layanan hukum waris dan hibah di Indramayu dengan akta waris, akta hibah, dan pembagian warisan yang sah secara hukum.",
    items: ["Surat Keterangan Waris", "Akta Hibah", "Pembagian Warisan", "Fatwa Waris"],
  },
  {
    slug: "perjanjian-pranikah",
    title: "Perjanjian Pranikah & Pascanikah",
    short: "Penyusunan perjanjian pemisahan harta sebelum atau setelah menikah dengan dasar hukum yang kuat.",
    description:
      "Penyusunan perjanjian pranikah dan pascanikah untuk perlindungan harta pasangan suami istri di Indramayu.",
    items: ["Perjanjian Pranikah", "Perjanjian Pascanikah", "Pemisahan Harta", "Konsultasi Pribadi"],
  },
  {
    slug: "akta-wasiat",
    title: "Akta Wasiat",
    short: "Pembuatan akta wasiat untuk memastikan kehendak Anda atas harta tertulis sah dan terdaftar.",
    description:
      "Layanan pembuatan akta wasiat di Indramayu untuk menegaskan keinginan pemilik harta secara tertulis dan resmi.",
    items: ["Wasiat Umum", "Wasiat Tertutup", "Pendaftaran Pusat Wasiat", "Konsultasi Penyusunan"],
  },
  {
    slug: "legalisasi-waarmerking",
    title: "Legalisasi & Waarmerking Dokumen",
    short: "Pengesahan tanda tangan (legalisasi) dan pendaftaran dokumen di bawah tangan (waarmerking).",
    description:
      "Layanan legalisasi tanda tangan dan waarmerking dokumen di Indramayu untuk memastikan dokumen sah digunakan.",
    items: ["Legalisasi Tanda Tangan", "Waarmerking Dokumen", "Salinan Resmi", "Cocok Asli"],
  },
];

export const CONTACT_INFO = {
  whatsappNumber: "6289609939045",
  whatsappLabel: "+62 896-0993-9045",
  email: "notarishelen234@gmail.com",
  addressLines: [
    "Jl. Jenderal Ahmad Yani No.37, RT.1",
    "Lemahabang, Kec. Indramayu",
    "Kabupaten Indramayu, Jawa Barat 45221",
  ],
  officeHours: ["Sen-Jum: 09.00-17.00 WIB", "Sabtu: dengan janji temu"],
};

export const scrollToContact = () => {
  document.getElementById("kontak")?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};
